import { render, staticRenderFns } from "./aparencia.vue?vue&type=template&id=da9166dc&"
import script from "./aparencia.vue?vue&type=script&lang=js&"
export * from "./aparencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports